import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmInvoiceTypeComponent} from '@shared/components/confirm-invoice-type/confirm-invoice-type.component';
import {Observable} from 'rxjs';
import urlJoin from 'url-join';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InvoiceModalService{
  constructor(private modalService: NgbModal, private http:HttpClient) {}

  manualGenerateInvoice(apartmentId: number, types: number[]): Observable<any> {
    const payload = { apartmentId, types };
    return this.http.post(urlJoin(environment.apiUrl, 'invoices/manual-generate'), payload);
  }

  openInvoiceModal():Promise<{ confirmed: boolean, selectedOptions:number[] }>{
    const modalRef = this.modalService.open(ConfirmInvoiceTypeComponent, {
      backdrop: true,
      keyboard: true,
    });
    return modalRef.result;
  }
}
